import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  public privacyUrl: SafeResourceUrl;

  constructor(public dialogRef: MatDialogRef<PrivacyComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public sanitizer: DomSanitizer) {
                this.privacyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.privacyUrl);
              }

  ngOnInit(): void {
    // const iframe = this.iframeElem.nativeElement; // this.hostElement.nativeElement.querySelector('iframe');
    // iframe.src = this.privacyUrl;
  }
  public sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url); // bypassSecurityTrustResourceUrl - bypassSecurityTrustUrl
  }
  public close() {
    this.dialogRef.close();
  }
}
